window.getSelectedEmbroideryVariants =
function() {

  let variants = [];

  const placement =
  document.getElementById(
    "placementType"
  )?.value;

  if (placement === "corner") {
    variants.push(
      EMBROIDERY_VARIANTS
      .placements.corner
    );
  }

  if (placement === "largeBack") {
    variants.push(
      EMBROIDERY_VARIANTS
      .placements.largeBack
    );
  }

  if (placement === "wrapAround") {
    variants.push(
      EMBROIDERY_VARIANTS
      .placements.wrapAround
    );
  }
  const maxFontSize = Math.max(
  ...[...document.querySelectorAll(".embroidery-text-layer")]
    .map(layer =>
      parseInt(layer.dataset.fontSize || 32)
    )
);

if (maxFontSize >= 48 && maxFontSize < 64) {

  variants.push(
    EMBROIDERY_VARIANTS.textSize.largeText
  );

}

if (maxFontSize >= 64) {

  variants.push(
    EMBROIDERY_VARIANTS.textSize.xlText
  );

}

  const finish =
  document.getElementById(
    "threadFinish"
  )?.value;

  if (finish === "metallic") {
    variants.push(
      EMBROIDERY_VARIANTS
      .threadFinish.metallic
    );
  }

  if (finish === "glow") {
    variants.push(
      EMBROIDERY_VARIANTS
      .threadFinish.glow
    );
  }

  console.log(
    "SELECTED VARIANTS:",
    variants
  );
const density =
document.getElementById(
  "stitchDensity"
)?.value;

if (density === "premium") {
  variants.push(
    EMBROIDERY_VARIANTS
    .density.premiumFill
  );
}

if (density === "luxury") {
  variants.push(
    EMBROIDERY_VARIANTS
    .density.luxuryFill
  );
}
const stitchType =
document.getElementById(
  "stitchType"
)?.value;

if (stitchType === "satin") {
  variants.push(
    EMBROIDERY_VARIANTS
    .stitchType.satin
  );
}

if (stitchType === "raised") {
  variants.push(
    EMBROIDERY_VARIANTS
    .stitchType.raised
  );
}

if (stitchType === "vintage") {
  variants.push(
    EMBROIDERY_VARIANTS
    .stitchType.vintage
  );
}
const outline =
document.getElementById(
  "outlineEmbroidery"
)?.value;

if (outline === "classic") {
  variants.push(
    EMBROIDERY_VARIANTS
    .outline.classic
  );
}

if (outline === "bold") {
  variants.push(
    EMBROIDERY_VARIANTS
    .outline.bold
  );
}

if (outline === "double") {
  variants.push(
    EMBROIDERY_VARIANTS
    .outline.double
  );
}
const shadow =
document.getElementById(
  "shadowEmbroidery"
)?.value;

if (shadow === "soft") {
  variants.push(
    EMBROIDERY_VARIANTS
    .shadow.soft
  );
}

if (shadow === "drop") {
  variants.push(
    EMBROIDERY_VARIANTS
    .shadow.drop
  );
}

if (shadow === "offset") {
  variants.push(
    EMBROIDERY_VARIANTS
    .shadow.offset
  );
}
const monogram =
document.getElementById(
  "monogramStyle"
)?.value;

if (monogram === "traditional") {
  variants.push(
    EMBROIDERY_VARIANTS
    .monogram.traditional
  );
}

if (monogram === "interlocking") {
  variants.push(
    EMBROIDERY_VARIANTS
    .monogram.interlocking
  );
}

if (monogram === "stacked") {
  variants.push(
    EMBROIDERY_VARIANTS
    .monogram.stacked
  );
}

if (monogram === "split") {
  variants.push(
    EMBROIDERY_VARIANTS
    .monogram.split
  );
}
const puff =
document.getElementById(
  "puff3d"
)?.value;

if (puff === "3d") {
  variants.push(
    EMBROIDERY_VARIANTS
    .puff.puff3d
  );
}

if (puff === "heavy") {
  variants.push(
    EMBROIDERY_VARIANTS
    .puff.heavy
  );
}
const applique =
  document.getElementById("appliqueType")?.value;

if (applique) {

  variants.push(
    EMBROIDERY_VARIANTS
      .applique.enabled
  );

}
const artworkLayer =
document.querySelector(
".embroidery-image-layer"
);

const artworkComplexity =
artworkLayer
?.dataset
?.complexity;



/* ARTWORK COMPLEXITY */

if (artworkComplexity === "Moderate") {

  variants.push(
    EMBROIDERY_VARIANTS.artworkComplexity.moderate
  );

}

if (artworkComplexity === "Complex") {

  variants.push(
    EMBROIDERY_VARIANTS.artworkComplexity.complex
  );

}

if (artworkComplexity === "Highly Complex") {

  variants.push(
    EMBROIDERY_VARIANTS.artworkComplexity.highlyComplex
  );

}
if (artworkLayer) {

  const width =
    artworkLayer.offsetWidth;

  if (width >= 200 && width < 300) {

    variants.push(
      EMBROIDERY_VARIANTS.artworkSize.medium
    );

  }

  if (width >= 300 && width < 400) {

    variants.push(
      EMBROIDERY_VARIANTS.artworkSize.large
    );

  }

  if (width >= 400 && width < 500) {

    variants.push(
      EMBROIDERY_VARIANTS.artworkSize.oversized
    );

  }

  if (width >= 500) {

    variants.push(
      EMBROIDERY_VARIANTS.artworkSize.jumbo
    );

  }

}  
console.log(
"SELECTED VARIANTS:",
variants
);

return variants;
};
function getEmbroideryProperties() {

  return {

    "Embroidery Text":
  Array.from(
    document.querySelectorAll(".fabric-text")
  )
  .map(el => el.textContent)
  .join(""),

    "Placement":
      document.getElementById(
        "placementType"
      )?.value || "",

    "Thread Finish":
      document.getElementById(
        "threadFinish"
      )?.value || "",

    "Applique":
      document.getElementById(
        "appliqueType"
      )?.value || "",

    "Density":
      document.getElementById(
        "stitchDensity"
      )?.value || "",

    "Stitch Type":
      document.getElementById(
        "stitchType"
      )?.value || "",

    "Monogram":
      document.getElementById(
        "monogramStyle"
      )?.value || "",

    "Shadow":
      document.getElementById(
        "shadowEmbroidery"
      )?.value || "",

    "Outline":
      document.getElementById(
        "outlineEmbroidery"
      )?.value || "",

    "Puff":
      document.getElementById(
        "puff3d"
      )?.value || ""

  };

}

window.getEmbroideryProperties =
  getEmbroideryProperties;